import React, { useState, useEffect } from 'react';
import './CustomAlert.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faCheckCircle, 
    faExclamationTriangle, 
    faTimesCircle, 
    faInfoCircle,
    faTimes 
} from '@fortawesome/free-solid-svg-icons';

const CustomAlert = ({ isOpen, onClose, type = 'info', title, message, confirmText = 'OK', onConfirm, showCancel = false, cancelText = 'Cancel' }) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setIsVisible(true);
        } else {
            const timeout = setTimeout(() => setIsVisible(false), 300);
            return () => clearTimeout(timeout);
        }
    }, [isOpen]);

    const getIcon = () => {
        switch (type) {
            case 'success':
                return faCheckCircle;
            case 'warning':
                return faExclamationTriangle;
            case 'error':
                return faTimesCircle;
            case 'info':
            default:
                return faInfoCircle;
        }
    };

    const getIconColor = () => {
        switch (type) {
            case 'success':
                return '#28a745';
            case 'warning':
                return '#ffc107';
            case 'error':
                return '#dc3545';
            case 'info':
            default:
                return '#17a2b8';
        }
    };

    const handleConfirm = () => {
        if (onConfirm) {
            onConfirm();
        }
        onClose();
    };

    const handleCancel = () => {
        onClose();
    };

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    if (!isVisible) return null;

    return (
        <div 
            className={`custom-alert-overlay ${isOpen ? 'show' : ''}`}
            onClick={handleOverlayClick}
        >
            <div className={`custom-alert ${isOpen ? 'show' : ''}`}>
                <div className="custom-alert-header">
                    <div className="custom-alert-icon">
                        <FontAwesomeIcon 
                            icon={getIcon()} 
                            style={{ color: getIconColor() }}
                        />
                    </div>
                    {title && <h3 className="custom-alert-title">{title}</h3>}
                    <button 
                        className="custom-alert-close"
                        onClick={onClose}
                        aria-label="Close"
                    >
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
                
                <div className="custom-alert-body">
                    <p className="custom-alert-message">{message}</p>
                </div>
                
                <div className="custom-alert-footer">
                    {showCancel && (
                        <button 
                            className="btn secondary"
                            onClick={handleCancel}
                        >
                            {cancelText}
                        </button>
                    )}
                    <button 
                        className="btn primary"
                        onClick={handleConfirm}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CustomAlert;